// Home page
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ThemePacks from "../components/ThemePacks";
import Subscriptions from "../components/Subscriptions";
import Services from "../components/Services";
import EventServices from '../components/EventServices';
import DailyFlowers from '../components/DailyFlowers';
import WeddingGarlands from '../components/WeddingGarlands';

export default function Home() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [locality, setLocality] = useState("Adyar, Chennai, TamilNadu");

  const handleFindNow = () => {
    const params = new URLSearchParams();
    if (searchTerm) params.set("q", searchTerm);
    if (locality) params.set("loc", locality);
    navigate(`/listings?${params.toString()}`);
  };

  return (
    <main className="max-w-[1440px] mx-auto px-4 md:px-8">
      {/*<!-- Hero Section with Search -->*/}
      <section className="py-8">
        <div className="relative h-[480px] rounded-3xl overflow-hidden shadow-2xl">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5)), url("https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X")`,
            }}
          ></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
            <h2 className="text-white text-4xl md:text-6xl font-black mb-6 tracking-tight drop-shadow-lg leading-tight">
              Hyperlocal Beauty for
              <br />
              Your Most Sacred Days
            </h2>
            
            <div className="w-full max-w-4xl bg-white p-3 rounded-2xl shadow-2xl flex flex-col md:flex-row gap-3">
              <div className="flex-1 flex items-center px-4 md:border-r border-[#e7e3cf]">
                <span className="material-symbols-outlined text-primary mr-3 text-2xl">
                  search
                </span>
                <input
                  className="w-full border-none focus:ring-0 text-base py-3"
                  placeholder="What are you looking for?"
                  type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="flex-1 flex items-center px-4 md:border-r border-[#e7e3cf]">
                <span className="material-symbols-outlined text-primary mr-3 text-2xl">
                  location_on
                </span>
                <input
                  className="w-full border-none focus:ring-0 text-base py-3"
                  placeholder="Select your locality"
                  type="text"
                        value={locality}
                        onChange={(e) => setLocality(e.target.value)}
                />
              </div>
                    <button onClick={handleFindNow} className="bg-primary text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-gold-dark transition-all whitespace-nowrap shadow-md">
                      Find Now
                    </button>
            </div>
          </div>
        </div>
      </section>

      {/* ThemePacks component (moved out) */}
      <ThemePacks />
      {/* Theme packs rendered by component above */}

      {/* Subscriptions (moved to its own component) */}
      <Subscriptions />

      {/* Our Services (moved to component) */}
      <Services />
      {/* Daily Flower Delivery (moved to component) */}
      <DailyFlowers />
      {/* Wedding Garlands (moved to component) */}
      <WeddingGarlands />
      {/* Professional Event Services (moved to component) */}
      <EventServices />
      
    </main>
  );
}
